import React, { useState } from "react";
import classes from "./Department.module.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import {
  FiSearch,
  FiFilter,
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiEye,
} from "react-icons/fi";
// Import the new modal
import AddDepartmentModal from "./AddDepartmentModal";

const Department = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Modal State
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  // Data (Location removed)
  const departments = [
    { id: 1, name: "Cardiology", code: "CARD", type: "Clinical", head: "Dr. John Adewale", status: "Active" },
    { id: 2, name: "Pediatrics", code: "PED", type: "Clinical", head: "Dr. Mary Johnson", status: "Active" },
    { id: 3, name: "General Surgery", code: "SURG", type: "Surgical", head: "Dr. David Okafor", status: "Active" },
    { id: 4, name: "Laboratory", code: "LAB", type: "Diagnostic", head: "Dr. Sarah Bello", status: "Active" },
    { id: 5, name: "Radiology", code: "RAD", type: "Diagnostic", head: "Dr. Michael Adeyemi", status: "Active" },
    { id: 6, name: "Pharmacy", code: "PHARM", type: "Support Services", head: "Mrs. Grace Adebayo", status: "Active" },
    { id: 7, name: "Emergency Department", code: "ER", type: "Emergency", head: "Dr. Daniel Ogunleye", status: "Active" },
    { id: 8, name: "Obstetrics & Gynaecology", code: "OBGYN", type: "Clinical", head: "Dr. Jane Williams", status: "Active" },
  ];

  return (
    <div className={classes.pageContainer}>
      {/* Add Department Modal */}
      <AddDepartmentModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} />

      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={classes.mainArea}>
        <Header toggleSidebar={toggleSidebar} />

        <div className={classes.content}>
          {/* Top Header */}
          <div className={classes.topHeader}>
            <h1 className={classes.pageTitle}>Department</h1>
            <p className={classes.pageSubtitle}>Manage all hospital departments</p>
          </div>

          {/* Toolbar */}
          <div className={classes.toolbar}>
            <div className={classes.searchWrapper}>
              <input
                type="text"
                placeholder="Search departments..."
                className={classes.searchInput}
              />
              <FiSearch className={classes.searchIcon} />
            </div>
            <div className={classes.toolbarRight}>
              <button className={classes.filterBtn}><FiFilter /> Filter</button>
              
              {/* --- UPDATED: Opens the Add Department Modal --- */}
              <button className={classes.addBtn} onClick={() => setIsAddModalOpen(true)}>
                <FiPlus /> Add Department
              </button>
            </div>
          </div>

          {/* Table */}
          <div className={classes.tableCard}>
            <table className={classes.dataTable}>
              <thead>
                <tr>
                  <th>Department Name</th>
                  <th>Code</th>
                  <th>Type</th>
                  <th>Department Head</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {departments.map((dept) => (
                  <tr key={dept.id}>
                    <td className={classes.nameCell}>{dept.name}</td>
                    <td className={classes.codeCell}>{dept.code}</td>
                    <td className={classes.typeCell}>{dept.type}</td>
                    <td className={classes.headCell}>{dept.head}</td>
                    <td>
                      <span className={classes.statusBadge}>{dept.status}</span>
                    </td>
                    <td>
                      <div className={classes.actions}>
                        <button className={classes.actionBtn}><FiEye /></button>
                        <button className={classes.actionBtn}><FiEdit2 /></button>
                        <button className={classes.actionBtn}><FiTrash2 /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Department;